import { css } from 'styled-components'

import { resolveThemeable, type Themeable } from '../themeable'
import type { FocusVisibleProps } from '.'

/**
 * Reusable styling for showing an external focus indicator.
 */
export const focusVisibleOutline = (outlineColor: Themeable<string>) => css<object>`
	outline: ${(props) => {
		const { isFocusVisible } = props as typeof props & FocusVisibleProps

		return isFocusVisible ? `2px solid ${resolveThemeable(outlineColor, props.theme)}` : 'none'
	}} !important;
	outline-offset: 2px;
`
